const Label = ({ children }) => {
  return <span className="bx--label">{children}</span>
}

export default Label;